import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TestsService } from 'src/app/feature/lab-configuration/tests/Services/tests.service';
import { BulkUploadService } from 'src/app/feature/manage-patients/bulk-upload/bulk-upload.service';
import { Constants } from 'src/app/shared/constants';
import { BulkUploadDocuments } from 'src/app/shared/error-messages';

import { LoaderService } from '../loader/loader.service';
import { NotificationService } from '../services/notification-service';
import { saveAs } from 'file-saver-es';

@Component({
    selector: 'app-clindx-upload',
    templateUrl: './clindx-upload.component.html',
    styleUrls: ['./clindx-upload.component.scss'],
    standalone: false
})
export class ClindxUploadComponent implements OnInit {
  @Input() fileType: string;
  @Output() fileChanged: EventEmitter<any> = new EventEmitter<any>();
  uploadFileName = '';
  uploadSuccess = false;
  uploadErrorText = '';
  uploadError = false;
  fileToupload: any;
  isFileValid = false;
  validationSuccess = false;
  document = new Array<number>();

  constructor(
    private testService: TestsService,
    private bulkUploadService: BulkUploadService,
    private loader: LoaderService,
    private notification: NotificationService) { }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }

  readFile(fileEvent) {
    this.csv2Array(fileEvent);
    const fileReader: FileReader = new FileReader();
    this.cancelFile();
    this.uploadSuccess = false;
    const file: File = fileEvent.target.files[0];
    fileEvent.target.value = '';
    const val = file.name.split('.');
    const extension = val[val.length - 1];
    const self = this;
    self.loader.show();
    if (extension.toLowerCase() !== this.fileType) {
      this.uploadErrorText = 'Upload of .pdf file allowed only';
      this.uploadError = true;
      self.loader.hide();
    } else {
      this.removeFileUploadError();
      if (file.size >= Constants.MAX_FILESIZE_25MB) {
        this.uploadErrorText = 'Maximum file size allowed to be uploaded is 25 mb';
        this.uploadError = true;
        self.loader.hide();
      } else {
        this.fileChanged.emit(file);
        // let array: Uint8Array;
        // fileReader.readAsArrayBuffer(file);
        // fileReader.onloadend = (x) => {
        //   array = new Uint8Array(fileReader.result as ArrayBuffer);
        //   self.document = new Array<number>();
        //   for (const byte of array) {
        //     self.document.push(byte);
        //     this.fileChanged.emit(self.document);
        //   }
        //   self.loader.hide();
        // };
        this.removeFileUploadError();
        this.uploadFileName = file.name;
        self.loader.hide();
      }
    }
  }
  csv2Array(fileInput: any) {
    // read file from inputthis.fileReaded = fileInput.target.files[0];
    const fileReaded = fileInput.target.files[0];
    const reader: FileReader = new FileReader();
    reader.readAsText(fileReaded);

    reader.onload = (e) => {
      const csv: any = reader.result;
      const allTextLines = csv.split('\n');
      const headers = allTextLines[0].split(',');
      const lines = [];
      for (let i = 0; i < allTextLines.length; i++) {
        // split content based on commalet data = allTextLines[i].split(',');
        const data = allTextLines[i].split(',');
        if (data.length === headers.length) {
          const tarr = [];
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          // log each row to see output console.log(tarr);
          lines.push(tarr);
        }
      }
      console.log('>>>>>>>>>>>>>>>>>', lines);
    }
  }
  
  downloadTemplate() {
    this.loader.show();
    this.testService.downloadTestParameterUploadTemplate().subscribe({
      next: (res: any) => {
      this.loader.hide();
      if (res && res.type !== 'text/plain') {
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8' });
        const file = 'Parameter_Upload_Template.csv';
        saveAs(blob, file);
      } else {
        this.notification.warn(BulkUploadDocuments.FILE_NOT_AVAILABLE);
      }
    }, error: (error) => {
      this.loader.hide();
      this.notification.warn(BulkUploadDocuments.FILE_CANT_DOWNLOAD_ERROR_MESSAGE);
    }
    });
  }

  public cancelFileCheck() {
    return this.uploadFileName !== '';
  }

  public cancelFile() {
    this.document = new Array<number>();
    this.uploadFileName = '';
  }

  public removeFileUploadError() {
    this.uploadErrorText = '';
    this.uploadError = false;
  }

}
